import './pop-up-content.scss';

class PopUp {
    constructor (element) {
        this.$popUp = element;
        this.isIos = /(iPhone|iPod|iPad)/i.test(navigator.platform);
    }

    initialize () {
        this.setEvents();
        this.lockBodyScroll(true, this.isIos);
    }

    lockBodyScroll (isLocked, touch) {
        let eventName = 'scroll.overlay';

        const freezeVp = function (e) {
            e.preventDefault();
        };

        if (touch === true) {
            eventName = 'touchmove.overlay';
        }

        if (isLocked === true) {
            document.body.addEventListener(eventName, freezeVp, false);
        } else {
            document.body.removeEventListener(eventName, freezeVp, false);
        }
    }

    closeOverlay () {
        this.$popUp.classList.remove('pop-up-content--open');

        window.setTimeout(() => {
            this.removeOverlay();
            this.lockBodyScroll(false, this.isIos);
        }, 500);
    }

    removeOverlay () {
        this.$popUp.parentNode.removeChild(this.$popUp);
    }

    setEvents () {
        const $close = this.$popUp.querySelector('[data-pop-up-content="close"]');

        if ($close) {
            $close.addEventListener('click', () => {
                this.closeOverlay();
            });
        }
    }
}

export { PopUp };
